require('./brokerIntervenerList.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerIntervenerItem = require('components/broker/brokerIntervener/brokerIntervenerItem/brokerIntervenerItem');

// @constants
const { INTERVENER_TYPE_TITULAR } = require('constants/index');


class BrokerIntervenerList extends React.Component {
    constructor(props) {
        super(props);
        this.hasOnlyOneOwner = this.hasOnlyOneOwner.bind(this);
        this.buildIntervenerList = this.buildIntervenerList.bind(this);
        this.buildLinkActions = this.buildLinkActions.bind(this);
        this.handleIntervenerNameChange = this.handleIntervenerNameChange.bind(this);
        this.handleIntervenerTypeChange = this.handleIntervenerTypeChange.bind(this);
        this.handleIntervenerRemove = this.handleIntervenerRemove.bind(this);
        this.handleIntervenerAddClick = this.handleIntervenerAddClick.bind(this);
        this.handleRestoreDefaultClick = this.handleRestoreDefaultClick.bind(this);
    }

    buildIntervenerList() {
        const { immStocksContractForm, isAdditionalSubscription, accountHolder } = this.props;
        const currentInterveners = immStocksContractForm.getIn(['steps', 0, 'interveners']);
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners'
        ]);
        const availableInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'availableInterveners'
        ]);
        const hasOnlyOneOwner = this.hasOnlyOneOwner(currentInterveners);

        return currentInterveners.map((intervener, index) => {
            const interveners = availableInterveners.push(intervener);
            const isOnlyOwner = hasOnlyOneOwner && intervener.get('type') === INTERVENER_TYPE_TITULAR;
            const isOwner = accountHolder && accountHolder === intervener.get('name')
            return (
                <BrokerIntervenerItem
                    key={index}
                    index={index}
                    isOwner={isOwner}
                    originalInterveners={interveners}
                    intervenerName={intervener.get('name')}
                    intervenerType={intervener.get('interventionType')}
                    onIntervenerNameChange={this.handleIntervenerNameChange}
                    onIntervenerTypeChange={this.handleIntervenerTypeChange}
                    onIntervenerRemove={this.handleIntervenerRemove}
                    isOnlyIntervener={originalInterveners.size === 1}
                    isOnlyOwner={isOnlyOwner}
                    nameLabelFormat={false}
                    useIntervenerCode
                    showRemoveIcon={!isOnlyOwner && !isAdditionalSubscription && !isOwner}
                    isAdditionalSubscription={isAdditionalSubscription}
                />
            );
        });
    }

    buildLinkActions() {
        const { immStocksContractForm } = this.props;
        const addIntervenerLabel = formatText('broker-stockIntervenerAddIntervenerLabel');
        const restoreValuesLabel = formatText('broker-stockIntervenerRestoreValuesLabel');
        const currentInterveners = immStocksContractForm.getIn(['steps', 0, 'interveners']);
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners'
        ]);
        const availableInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'availableInterveners'
        ]);
        let addLink;
        let restoreLink;

        if (!availableInterveners.isEmpty()) {
            addLink = (
                <span>
                    <OKButton
                        id="btnBrokerIntervenerListAddElement"
                        modifier="link-complementary"
                        onClick={this.handleIntervenerAddClick}
                    >
                        {addIntervenerLabel}
                    </OKButton>
                    <span className="intervener-list__action-links"> | </span>
                </span>
            );
        }

        if (currentInterveners.size !== originalInterveners.size) {
            restoreLink = (
                <span>
                    <OKButton
                        id="btnBrokerIntervenerListRemoveElement"
                        modifier="link-complementary"
                        onClick={this.handleRestoreDefaultClick}
                    >
                        {restoreValuesLabel}
                    </OKButton>
                </span>
            );
        }

        return (
            <div>
                {addLink}
                {restoreLink}
            </div>
        );
    }

    handleIntervenerAddClick(e) {
        e.preventDefault();
        this.props.addIntervener();
    }

    handleIntervenerNameChange(index, name) {
        const { immStocksContractForm } = this.props;
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners'
        ]);
        this.props.setIntervenerName(index, name, originalInterveners);
    }

    handleIntervenerRemove(index) {
        const { immStocksContractForm, removeIntervener } = this.props;
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners'
        ]);
        removeIntervener(index, originalInterveners);
    }

    handleIntervenerTypeChange(index, type) {
        this.props.setIntervenerType(index, type);
    }

    handleRestoreDefaultClick(e) {
        e.preventDefault();
        const { immStocksContractForm } = this.props;
        const originalInterveners = immStocksContractForm.getIn([
            'steps',
            0,
            'originalInterveners'
        ]);
        this.props.restoreDefaultInterveners(originalInterveners);
    }

    hasOnlyOneOwner(currentInterveners) {
        const onlyOwnersList = currentInterveners.filter(intervener => intervener.get('type') === INTERVENER_TYPE_TITULAR);
        return onlyOwnersList.size <= 1;
    }

    render() {
        const { immStocksContractForm } =  this.props;
        let subtitle;
        if(immStocksContractForm.get('contractFund') &&
            immStocksContractForm.getIn(['contractFund','contractNumber'])
        ){
            subtitle = (
                <p className="intervener-list__subtitle">
                    Recuerda cambiar el esquema de intervinencia del otro contrato para que se genere uno nuevo
                </p>
            );
        }
        const intervenerList = this.buildIntervenerList();
        const linkActions = this.buildLinkActions();
        return (
            <section className="intervener-list">
                <header className="intervener-list__header">
                    <h3 className="intervener-list__title">
                        <FormattedText value="brokerHireInvestmentStep1-selction" />
                    </h3>
                    <OKTooltip
                        offset={[15, 5]}
                        content="brokerIntevenerItem-tooltipFund"
                        placement="right"
                    />
                    {subtitle}
                </header>

                <section className="intervener-list__content">
                    {intervenerList}
                    {linkActions}
                </section>
            </section>
        );
    }
}

BrokerIntervenerList.propTypes = {
    originalInterveners: PropTypes.array,
    immStocksContractForm: PropTypes.object,
    immAccounts: PropTypes.object,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    requestAccountInterveners: PropTypes.func,
    isAdditionalSubscription: PropTypes.bool,
    accountHolder: PropTypes.string
};

module.exports = BrokerIntervenerList;
